export const MembershipSocialAuthProviders = {
  GOOGLE: 'GOOGLE',
  MICROSOFT: 'MICROSOFT',
  OIDC: 'OIDC'
};